<template v-if="loaded">
	<section class="overview overview--vacancy" ref="results">
		<div class="grid">
			<div class="cell cell--1 cell--medium-2/3">
				<div class="overview__outer">
					<div>
						<button
							class="overview__show-filters-btn btn btn--a btn--fill-outline btn--has-icon"
							@click="toggleFiltersOverlay()"
						>
							<span>Filters</span>
							<span class="btn__icon">
								<Icon name="filter" />
							</span>
						</button>
						<!-- Posts -->
						<div
							v-if="headers.total < 1 || (!headers.total && !isFetching)"
							:class="classes"
						>
							<div class="heading--5">0 resultaten</div>
							<div class="card">
								<h2 v-if="!noResultsText">
									Probeer je zoekopdracht aan te passen.
								</h2>
								<h2 v-else>{{ noResultsText }}</h2>
								<div class="button-container">
									<button @click="togglePopup" class="btn btn--small btn--b">
										Ga voor mij opzoek
									</button>

									<!-- <button @click="togglePopupJobAlert" class="btn btn--fill-outline btn--small btn--a">
                                        Hou mij op de hoogte
                                    </button> -->
									<button class="btn btn--fill-outline btn--small btn--a">
										<a href="/contact"> Hou mij op de hoogte </a>
									</button>
								</div>
							</div>
						</div>
						<div v-else :class="classes">
							<div class="heading--5">{{ searchResultsTitle }}</div>
							<template v-for="post in filteredPosts">
								<vacancy-teaser
									:title="post.title.rendered"
									:link="post.link"
									:excerpt="post.acf.vacancy_intro"
									:salary="post.acf.vacancy_salary"
									:company_logo="post.acf.vacancy_company_logo"
									:location="post.acf.vacancy_location"
									:jobHours="post.acf.vacancy_job_hours"
									:date="post.acf.vacancy_publication_date"
								>
								</vacancy-teaser>
							</template>
						</div>
						<!-- LOADING -->
						<div class="overview__actions">
							<div v-if="isFetching">
								<svg
									xmlns=" w3.org xmlns:xlink="
									w3.org
									style="
										margin: auto;
										background: rgb(255, 255, 255);
										display: block;
										shape-rendering: auto;
									"
									width="60px"
									height="60px"
									viewBox="0 0 100 100"
									preserveAspectRatio="xMidYMid"
								>
									<circle
										cx="50"
										cy="50"
										fill="none"
										stroke="#009B96"
										stroke-width="5"
										r="35"
										stroke-dasharray="164.93361431346415 56.97787143782138"
									>
										<animateTransform
											attributeName="transform"
											type="rotate"
											repeatCount="indefinite"
											dur="1s"
											values="0 50 50;360 50 50"
											keyTimes="0;1"
										></animateTransform>
									</circle>
								</svg>
							</div>
							<div
								class="overview__pagination"
								v-if="!isFetching && fetchCompleted && headers['pages'] > 1"
							>
								<a
									href="#"
									data-page="prev"
									@click="setPage"
									:hidden="query['page'] === 1"
									><Icon name="arrow" /> <span class="text">Vorige</span></a
								>
								<div
									v-for="n in pages"
									:key="n"
									:class="{ currentPage: n == query['page'] }"
								>
									<a href="#" :data-page="n" @click="setPage">{{ n }}</a>
								</div>
								<a
									href="#"
									data-page="next"
									@click="setPage"
									:hidden="query['page'] === headers['pages']"
									><span class="text">Volgende</span> <Icon name="arrow"
								/></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cell cell--1 cell--medium-1/3 cell--medium-order-start">
				<div class="overview__sidebar overview-filters" v-if="fetchCompleted">
					<div class="overview-filters__inner">
						<div class="overview-filters__header">
							<div class="overview-filters__title">Verfijn zoekopdracht</div>
							<div class="overview-filters__reset-link">
								<a :href="resetLink()">Reset filters</a>
							</div>
						</div>
						<section class="overview-filters__filters">
							<toggle-content
								name="filter"
								label="Wat is je plaats?"
								:toggled="true"
								icon="chevron"
							>
								<div
									class="overview-filters__item overview-filters__item--text"
								>
									<div class="overview-filters__input-container">
										<input
											class="overview-filters__input-text"
											type="text"
											:value="query.city"
											placeholder="Stad"
											name="city"
											id="city"
											v-on:keyup.enter="handleCityChange($event)"
										/>
										<button
											class="overview-filters__input-clear"
											v-if="query.city"
											@click="handleCityClear($event)"
										>
											<span class="visually-hidden">Wis stad</span>
											<span class="btn__icon">
												<Icon name="close" />
											</span>
										</button>
									</div>
								</div>

								<div
									class="overview-filters__item-br overview-filters__item--text"
								>
									<label for="distance">Afstand</label>
									<div class="overview-filters__input-container">
										<input
											class="overview-filters__input-range"
											type="range"
											:value="query.distance"
											name="distance"
											id="distance"
											min="1"
											max="4"
											step="1"
											v-on:input="handleDistanceChange($event)"
										/>
										<div>
											Afstand tot werkplek:
											<span id="distanceText">{{
												distanceOptions[query.distance - 1]
											}}</span>
										</div>
									</div>
								</div>
							</toggle-content>

							<toggle-content
								v-for="(category, index) in terms"
								:key="category.taxonomy.name"
								v-if="category.taxonomy.name !== 'business_unit'"
								name="filter"
								:label="getCategoryTitle(category.taxonomy)"
								:index="index"
								:toggled="true"
								icon="chevron"
							>
								<div>
									<ul class="overview-filters__list">
										<li
											class="overview-filters__item overview-filters__item--checkbox"
											v-for="term in category.terms"
											:key="term.term_id"
										>
											<input
												class="overview-filters__input-checkbox"
												type="checkbox"
												:value="term.term_id"
												:name="category.taxonomy.name"
												v-model.number="activeParams"
												:id="term.slug"
												:checked="term.checked"
												@change="
													handleFilterChange({ event: $event, data: term })
												"
											/>
											<label class="overview-filters__label" :for="term.slug">{{
												decodeHtmlEntities(term.name)
											}}</label>
										</li>
									</ul>
								</div>
							</toggle-content>
						</section>
					</div>
					<button
						class="overview-filters__mobile-cta btn btn--a"
						@click="toggleFiltersOverlay()"
					>
						<span>{{ filterButtonText() }}</span>
					</button>
				</div>
				<div class="overview__sidebar m-top-sm" v-if="fetchCompleted">
					<button @click="togglePopupJobAlert" class="btn btn--small btn--a">
						<span icon="btn__icon">
							<svg
								width="1.5em"
								height="1.5em"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12.0009 5C13.4331 5 14.8066 5.50571 15.8193 6.40589C16.832 7.30606 17.4009 8.52696 17.4009 9.8C17.4009 11.7691 17.846 13.2436 18.4232 14.3279C19.1606 15.7133 19.5293 16.406 19.5088 16.5642C19.4849 16.7489 19.4544 16.7997 19.3026 16.9075C19.1725 17 18.5254 17 17.2311 17H6.77066C5.47638 17 4.82925 17 4.69916 16.9075C4.54741 16.7997 4.51692 16.7489 4.493 16.5642C4.47249 16.406 4.8412 15.7133 5.57863 14.3279C6.1558 13.2436 6.60089 11.7691 6.60089 9.8C6.60089 8.52696 7.16982 7.30606 8.18251 6.40589C9.19521 5.50571 10.5687 5 12.0009 5ZM12.0009 5V3M9.35489 20C10.0611 20.6233 10.9888 21.0016 12.0049 21.0016C13.0209 21.0016 13.9486 20.6233 14.6549 20"
									stroke="#FFFFFF"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</span>
						<span>Job alert instellen</span>
					</button>
				</div>
				<slot v-if="fetchCompleted"></slot>
			</div>
		</div>
	</section>
</template>

<script>
import Icon from "./Icon.vue";
import { store } from "./store.js";
import VacancyTeaser from "./VacancyTeaser.vue";
import ToggleContent from "./ToggleContent.vue";
import axios from "axios";

export default {
	name: "VacancyOverview",
	components: {
		Icon,
		VacancyTeaser,
		ToggleContent: ToggleContent,
	},
	data() {
		return {
			termsApiURL: `/wp-json/api/v1/terms?cache=0`,
			loaded: false,
			posts: [],
			activeParams: [],
			query: {
				page: 1,
				per_page: 10,
				_embed: 1,
				acf_format: "standard",
				distance: 4,
			},
			noResultsText: "",
			/**
			 * This is a list of 'safe' params to use with the WP REST API query.
			 * Other parameters can create conflicts.
			 *
			 * This array can be extended to include custom params such as taxonomies
			 */
			params: [
				"context",
				"page",
				"per_page",
				"search",
				"after",
				"before",
				"exclude",
				"include",
				"offset",
				"order",
				"orderby",
				"_embed",
				"acf_format",
				"employment-type",
				"job-type",
				"education",
				"weekly-hours",
				"city",
				"distance",
			],
			history: {
				omit: ["per_page", "_embed", "orderby", "acf_format"],
			},
			headers: {},
			isFetching: false,
			fetchCompleted: false,
			store,
			terms: [],
			filterOpenClass: "js-state-filter-overlay-open",
			overviewClass: "overview__list",
			distanceOptions: ["10km", "20km", "50km", "100km"],
		};
	},
	computed: {
		filteredPosts() {
			return this.posts;
		},
		classes() {
			return ["overview", this.overviewClass].join(" ");
		},
		pages() {
			let numShown = 5;
			numShown = Math.min(numShown, this.headers.pages);

			let first = this.query.page - Math.floor(numShown / 2);
			first = Math.max(first, 1);
			first = Math.min(first, this.headers.pages - numShown + 1);

			return [...Array(numShown)].map((k, i) => i + first);
		},
		searchResultsTitle() {
			let title = "";

			if (!this.headers.total) {
				title = "";
			} else if (this.headers.total == 1) {
				if (this.query["search"]) {
					title = `1 resultaat voor '${this.query["search"]}'`;
				} else {
					title = `1 resultaat`;
				}
			} else {
				if (this.query["search"]) {
					title = `${this.headers.total} resultaten voor '${this.query["search"]}'`;
				} else {
					title = `${this.headers.total} resultaten`;
				}
			}

			return title;
		},
	},
	methods: {
		async fetchData() {
			this.posts = [];
			this.loaded = true;
			this.isFetching = true;

			if (this.query["search"] && this.query["search"]?.[0].length !== 0) {
				this.query.orderby = "relevance";
			} else {
				this.query.orderby = "vacancy_publication_date";
			}

			// Create a safe WP Query using permitted params
			let safeQuery = {};

			Object.keys(this.query).map((p) => {
				if (this.params.includes(p)) safeQuery[p] = this.query[p];
			});

			// Build the url query using origin-relative endpoint to avoid SITE_URL mismatches
			let url = [
				this.store.endpoints["vacancy"],
				this.buildUrlQuery(safeQuery),
			].join("");

			try {
				const response = await fetch(url);

				if (response.ok) {
					const data = await response.json();

					// Map headers from response. Headers are used to determine if there are additional pages surrounding a query.
					let headers = {
						total: "X-WP-Total",
						pages: "X-WP-TotalPages",
						link: "Link",
					};

					Object.keys(headers).forEach((key) => {
						const header = response.headers.get(headers[key]);
						const value = isNaN(header) ? header : parseInt(header) || 0;
						headers[key] = value;
					});

					this.headers = headers;
					this.replaceState(safeQuery);

					this.$nextTick(() => {
						this.posts = data;
						this.fetchCompleted = true;
						this.isFetching = false;
					});
				}
			} catch (error) {
				this.handleError(error);
			}
		},
		getState(query = false) {
			query = query ? query : this.buildJsonQuery(window.location.search);
			let params = [];
			Object.keys(query).map((key) => {
				this.$set(this.query, key, query[key]);

				let param = query[key];

				// Get all active filters and store in an array
				if (Array.isArray(param)) {
					let t = param.map((a) => {
						// Exclude the search and pagination parameter
						if (key !== "search" || key !== "page") {
							return a;
						}
					});
					params.push(t);
				}
			});

			// Active terms are grouped by taxonomy, for the activeparams we need to turn this into a flat array
			this.activeParams = params.reduce((a, b) => a.concat(b), []);

			return this;
		},
		replaceState(query) {
			let history = {};
			Object.keys(query).map((p) => {
				// check if the parameter is a filter or search/page
				// for filters, the array is converted to a comma separated string
				if (p === "search" || p === "page") {
					// Exclude the first page from the parameters
					if (!(p === "page" && this.query.page === 1)) {
						history[p] = query[p];
					}
				} else {
					let param = query[p];

					if (Array.isArray(param)) {
						history[p] = param.join(",");
					}
				}
			});

			let state = this.buildUrlQuery(history, this.history.omit);
			window.history.replaceState(null, null, window.location.pathname + state);

			return this;
		},
		getUrlParams(query) {
			return new URLSearchParams(query).toString();
		},
		// Turn the query into a URL Query string
		buildUrlQuery(query, omit = false) {
			let q = Object.keys(query)
				.map((k) => {
					if (omit && omit.includes(k)) return false;
					const parameter = JSON.parse(JSON.stringify(query[k]));

					if (Array.isArray(parameter)) {
						if (parameter.length > 0) {
							const a = parameter.join(",");
							return `${k}=${a}`;
						}
					} else {
						if (query[k]) return `${k}=${query[k]}`;
					}
				})
				.filter((k) => k)
				.join("&");
			return q !== "" ? "?" + q : "";
		},
		// Turn the query into a json object
		buildJsonQuery(query) {
			if (query === "") return false;
			let params = new URLSearchParams(query);
			let q = {};

			// Set keys in object and get values
			params.forEach(function (value, key) {
				if (key !== "search" && key !== "city") {
					if (!q.hasOwnProperty(key)) {
						let a = value.split(",");
						a = a.map((b) => Number(b));

						q[key] = a;
					}
				} else {
					if (!q.hasOwnProperty(key)) q[key] = value;
				}
			});
			return q;
		},
		async fetchTerms() {
			const terms = await (await fetch(this.termsApiURL)).json();
			this.terms = this.orderHoursTerms(terms);
		},
		handleError(response) {
			// eslint-disable-next-line no-undef
			if (process.env.NODE_ENV === "development") {
				console.dir(response);
			}

			this.isFetching = false;
		},
		handleFilterChange(event) {
			const taxonomy = event.data.taxonomy;
			const term = Number(event.data.term_id);

			event.data.checked = !event.data.checked;

			const checkbox = document.getElementById("p_" + event.data.slug);
			if (checkbox) {
				// Check the checkbox if the event.data.checked is true, uncheck it if false
				checkbox.checked = event.data.checked;
			}

			let terms = this.query.hasOwnProperty(taxonomy)
				? this.query[taxonomy]
				: [term]; // get other query or initialize.
			// Toggle, if the taxonomy exists, filter it out, otherwise add it.
			if (this.query.hasOwnProperty(taxonomy)) {
				terms = terms.includes(term)
					? terms.filter((e) => e !== term)
					: [...terms, term];
			}

			this.updateQuery(taxonomy, terms);

			return this;
		},
		handleCityChange(event) {
			const userCity = event.target.value;

			this.updateQuery("city", userCity);

			return this;
		},
		handleCityClear(event) {
			this.updateQuery("city", null);

			return this;
		},
		handleDistanceChange(event) {
			this.query.distance = event.target.value;
			const distanceValue = document.getElementById("distanceText");
			distanceValue.textContent = this.distanceOptions[this.query.distance - 1];

			// Distance display only; no city logic here
			// this.updateQuery('city', userCity);
		},
		updateQuery(taxonomy, terms) {
			this.query[taxonomy] = terms;
			this.query["page"] = 1;

			this.fetchData();
		},
		setPage(event) {
			event.preventDefault();

			const nextPage = event.target.dataset.page;
			let page = this.query["page"];

			if (nextPage === "prev") {
				page--;
			} else if (nextPage === "next") {
				page++;
			} else {
				page = Number(nextPage);
			}

			this.query["page"] = page;

			this.scrollToTop();

			this.fetchData();
		},
		getCategoryTitle(taxonomy) {
			if (this.store.filterLabels.hasOwnProperty(taxonomy.name)) {
				return this.store.filterLabels[taxonomy.name];
			} else {
				return taxonomy.label;
			}
		},
		getCompanyLogo(image) {
			return image;
		},
		resetLink() {
			let url = window.location.pathname;

			return url;
		},
		scrollToTop() {
			const element = this.$refs["results"];
			const top = element.offsetTop;

			window.scrollTo({ left: 0, top: top, behavior: "instant" });
		},
		toggleFiltersOverlay() {
			document.documentElement.classList.toggle(this.filterOpenClass);
		},
		filterButtonText() {
			return `Toon resultaten (${this.headers.total})`;
		},
		togglePopup() {
			const form = document.getElementById("no-results-form");
			if (!form) {
				return;
			}
			if (form.style.display === "none") {
				form.style.display = "block";
				form.style.visibility = "visible";
			} else {
				form.style.display = "none";
				form.style.visibility = "hidden";
			}
		},
		togglePopupJobAlert() {
			const form = document.getElementById("job-alert-form");
			if (!form) {
				return;
			}
			if (form.style.display === "none") {
				form.style.display = "block";
				form.style.visibility = "visible";
			} else {
				form.style.display = "none";
				form.style.visibility = "hidden";
			}

			const sourceInput = document.getElementById("city");
			const targetInput = document.getElementById("input_city");
			if (sourceInput && targetInput) {
				targetInput.value = sourceInput.value;
			}
		},
		displayMessage(message, type) {
			const introElement = document.getElementById("intro");

			const existingMessage = introElement.nextElementSibling;
			if (
				existingMessage &&
				existingMessage.classList.contains("form-message")
			) {
				existingMessage.remove();
			}

			const messageElement = document.createElement("div");
			messageElement.classList.add(
				"form-message",
				"gfield",
				"gfield--width-full",
				type
			);
			messageElement.innerHTML = message;

			if (type === "error") {
				messageElement.style.color = "#dc5a64";
			} else if (type === "success") {
				messageElement.style.color = "#009b96";
			}

			introElement.insertAdjacentElement("afterend", messageElement);
			messageElement.scrollIntoView({ behavior: "smooth", block: "center" });
		},
		orderHoursTerms(terms) {
			if (!Array.isArray(terms) || terms.length === 0) return terms;

			const hoursOrderMap = new Map([
				["0-16", 0],
				["16-24", 1],
				["24-32", 2],
				["32-40", 3],
			]);

			return terms.map((item) => {
				if (
					item.taxonomy?.name === "weekly-hours" &&
					Array.isArray(item.terms)
				) {
					return {
						...item,
						terms: [...item.terms].sort((a, b) => {
							const indexA = hoursOrderMap.get(a.name) ?? Infinity;
							const indexB = hoursOrderMap.get(b.name) ?? Infinity;
							return indexA - indexB;
						}),
					};
				}
				return item;
			});
		},
		decodeHtmlEntities(str) {
			const tempElement = document.createElement("div");
			tempElement.innerHTML = str;
			return tempElement.textContent || tempElement.innerText;
		},
	},
	props: ["noresults"],
	mounted: function () {
		if (this.noresults) {
			this.noResultsText = this.noresults;
		}
		this.getState();
		this.fetchData();
		this.fetchTerms();

		const externalForm = document.getElementById("gform_job_alert");

		if (externalForm) {
			externalForm.addEventListener("submit", (event) => {
				event.preventDefault();

				const consentCheckbox = externalForm.querySelector(
					'[name="input_consent_1"]'
				);
				if (consentCheckbox && !consentCheckbox.checked) {
					this.displayMessage("Vul alle verplichte velden in.", "error");
					return;
				}

				const formData = new FormData(externalForm);

				axios
					.post("/wp-json/vacancy/v2/axiosJobAlert", formData)
					.then((response) => {
						if (!response.data.success) {
							let errorMessages = "";
							// Loop through the error_data object
							for (const [field, message] of Object.entries(
								response.data.error_data
							)) {
								errorMessages += `${message}<br>`; // Format each error message
							}

							this.displayMessage(errorMessages, "error");
						} else {
							this.displayMessage(
								"Bedankt! Uw inzending is ontvangen.",
								"success"
							);
							setTimeout(() => {
								this.togglePopupJobAlert();
							}, 1000);
						}
					})
					.catch((error) => {
						console.error("Formulier indienen mislukt", error);
						this.displayMessage("Formulier indienen mislukt.", "error");
					});
			});
		}
	},
};
</script>

<style scoped></style>
